import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getUserManager, usesWidgetSignIn } from '../auth/oktaConfig';
import { standaloneLogoutRedirectUrl } from '../lib/environment-config';
import { WidgetSignedOut } from './WidgetSignedOut';

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const LoggedOut = () => {
  const history = useHistory();
  // In the Forms widget, stay here: going on to a signed-in page would ask the widget for a token
  // right after the user signed out.
  const [signedOutOfWidget, setSignedOutOfWidget] = useState(false);

  useEffect(() => {
    const um = getUserManager();
    um.endLogout().then(() => {
      if (usesWidgetSignIn()) {
        setSignedOutOfWidget(true);
      } else if (localStorage.getItem('_isStandaloneUser')) {
        localStorage.removeItem('_isStandaloneUser');
        window.open(standaloneLogoutRedirectUrl, '_self');
      } else if (localStorage.getItem('idp') === 'fnf') {
        history.push('/');
      } else {
        history.push(window.location.pathname.includes('templates') ? '/templates' : '/envelopes');
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, []);

  return signedOutOfWidget ? <WidgetSignedOut /> : null;
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default LoggedOut;
